import React, {useState} from 'react';
import defaultImage from "../../../Image/defaultBook.png";
import "./BookBoxDrawerCart.css";
import {useDispatch, useSelector} from "react-redux";
import separate from "../../functions/separate/separate";
import {closeSnackbar as closeSnackbarAction, enqueueSnackbar as enqueueSnackbarAction} from "../../../redux/actions";
import setColor from "../../functions/setColor/setColor";
import setIcon from "../../functions/setIcon/setIcon";
import {Link} from "react-router-dom";
import {decrementOfProduct, incrementOfProduct, removeOfCart, selCart} from "../../../stores/cart/cartSlice";
import {notification} from "../../functions/notification/notificationFunction";

function BookBoxDrawerCart(props) {

    const dispatch = useDispatch();
    const {data, disabled} = props;
    const cart = useSelector(selCart);

    const enqueueSnackbar = (...args) => dispatch(enqueueSnackbarAction(...args));
    const closeSnackbar = (...args) => dispatch(closeSnackbarAction(...args));

    function handleClick(type, text, content, typePersist) {
        enqueueSnackbar({
            message:
                <div>
                    <div
                        className="upDiv"
                        style={{backgroundColor: setColor(type)}}
                    />
                    <div
                        className="ContentNotification"
                    >
                        {content}
                        {/*<h3>{text}</h3>*/}
                        {setIcon(type)}
                    </div>
                </div>,
            options: {
                key: new Date().getTime() + Math.random(),
                variant: type,
                action: key => (
                    <i
                        className="fa fas fa-times info"
                        style={{color: setColor(type)}}
                        onClick={() => closeSnackbar(key)}
                    />
                ),
                persist: typePersist ? typePersist : false
            },
        });
    }


    return (
        <div className={`DivProductDrawer d-flex`}>
            {!disabled &&
            <i
                className="fas fas fa-times c-pointer mt-1"
                onClick={() => dispatch(removeOfCart(data.product_id))}
            />
            }
            <div className="d-flex flex-column w-100 mr-3">
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                        <Link
                            to={`/products/${data.slug}`}
                            onClick={()=>dispatch({type: "DRAWER_CART", data: false})}
                            className="m-0 titleBookDrawer">{data.name}</Link>
                        {!disabled && data.type !== "marghome" &&
                        <div className="d-flex flex-row ParentButtonCount">
                            <button onClick={() => {
                                let weight = 0;
                                cart.forEach(item => {
                                    weight += item.weight * item.quantity
                                });
                                if (weight >= 30000) {
                                    dispatch(notification("error", "", <h3>وزن محصولات انتخابی بیش از حد مجاز است لطفا سفارش فعلی
                                        را تکمیل کرده و مجددا اقدام فرمایید</h3>, false))
                                } else if ((weight + parseInt(data.weight)) >= 30000) {
                                    dispatch(notification("error", "", <h3>وزن محصولات انتخابی بیش از حد مجاز است لطفا سفارش فعلی
                                        را تکمیل کرده و مجددا اقدام فرمایید</h3>, false))
                                } else {
                                    dispatch(incrementOfProduct(data.product_id))
                                    // dispatch({
                                    //     type: "INC_PRODUCT_CART",
                                    //     data: data.product_id
                                    // })
                                }
                            }}
                            >
                                <i className="fas fa-plus"/>
                            </button>
                            <div className="d-flex justify-content-center align-items-center">{data.quantity}</div>
                            <button
                                onClick={() => {
                                    dispatch(decrementOfProduct(data.product_id))
                                    // dispatch({
                                    //     type: "DEC_PRODUCT_CART",
                                    //     data: data.product_id
                                    // })
                                }}
                                disabled={data.quantity === 0}>
                                <i className="fas fa-minus"/>
                            </button>
                        </div>
                        }
                    </div>
                    <img src={data.image !== undefined ? data.image : data.images ? data.images.length !== 0 && data.images[0].url : defaultImage} alt=""/>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center DiscountDiv" style={{visibility:data.discounted_percent === 0 ? "hidden" : "visible"}}>
                        <h3>{separate(data.price)} ریال</h3>
                        <h3>%{data.discounted_percent}</h3>
                    </div>
                    <div>
                        <h3 className="CountAndPriceDrawer">
                            {data.discounted_price ? data.discounted_price !== 0 ? separate(data.discounted_price) : separate(data.price) : separate(data.price)} ریال
                            <i
                                className="fas fas fa-times c-pointer mx-2"
                            />
                            {data.quantity}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookBoxDrawerCart;